/* Plain deferred script; the pure map also runs under node --test. */
(function () {
  'use strict';

  // Copy values are keys in the localized #traceform-config copy object; null
  // keeps what the page already shows. Plan 61 T6: one entry per round-1 concept,
  // the headline echoing the ad's own words. C11/C12 name the race, which the
  // ad may do (bible ch. 05 s4.6), and carry the not-affiliated line with it.
  // Plan 77 F2: `primary` is the entry the first screen leads with – `upload` (the
  // visitor's own run), `race` (a course, no file) or `example`; `hint` is one line
  // under the button that gets the file ready before the picker opens.
  var unchanged = { concept: null, variant: null, audience: 'self', cta: null, headline: null, subhead: null, disclaimer: null, primary: 'upload', hint: null };
  function entry(concept, fields) {
    return Object.assign({}, unchanged, { concept: concept, cta: fields.audience === 'gift' ? 'landingC4Cta' : 'landingC9Cta' }, fields);
  }
  var landings = {
    C1: entry('C1', { headline: 'landingC1Headline' }),
    // Framed is the gift ad's starting format, set here and visible in the
    // first-screen switch; picking Gift on the page never changes the format.
    C4: entry('C4', { variant: 'framed', audience: 'gift', cta: 'landingC4Cta', headline: 'landingGiftHeadline', subhead: 'landingGiftSubhead' }),
    C6: entry('C6', { headline: 'landingC6Headline' }),
    C9: entry('C9', { variant: 'framed', cta: 'landingC9Cta', headline: 'landingC9Headline', subhead: 'landingC9Subhead' }),
    C10: entry('C10', { headline: 'landingC10Headline' }),
    C11: entry('C11', { headline: 'landingC11Headline', disclaimer: 'landingRaceDisclaimer' }),
    C12: entry('C12', { headline: 'landingC12Headline', disclaimer: 'landingRaceDisclaimer' }),
    // Plan 75, `copy/ads/race-gift.md`: the headline is the ad's own. A race entry
    // names the course the race-course page picks on arrival; the two general ones
    // land here in gift mode, at the print price their "From $119" names. Named
    // explicitly since plan 81 N11a made Framed the page's own starting format.
    RG1: race('RG1', 'nyc'),
    RG2: race('RG2', 'nyc'),
    RG3: race('RG3', 'nyc'),
    RG4: race('RG4', 'cim'),
    RG5: race('RG5', 'cim'),
    RG6: race('RG6', 'cim'),
    RG7: entry('RG7', { variant: 'print', audience: 'gift', cta: 'landingC4Cta', headline: 'landingRG7Headline', subhead: 'landingGiftSubhead' }),
    RG8: entry('RG8', { variant: 'print', audience: 'gift', cta: 'landingC4Cta', headline: 'landingRG8Headline', subhead: 'landingGiftSubhead' }),
    // Spec 2026-10-14: the runner's own run from a share card, at the print price
    // the ad names (explicit since plan 81 N11a). RG10 names Chicago, so it
    // carries the not-affiliated line.
    RG9: entry('RG9', { variant: 'print', cta: 'landingC9Cta', headline: 'landingRG9Headline', subhead: 'landingRG9Subhead' }),
    RG10: entry('RG10', { variant: 'print', cta: 'landingC9Cta', headline: 'landingRG10Headline', subhead: 'landingRG9Subhead', disclaimer: 'landingRaceDisclaimer' }),
    // `copy/ads/round2.md`: the runner's own Chicago, on the course page.
    RG11: race('RG11', 'chicago'),
    // `copy/ads/round3.md`: the share-card demo video, at the "From $119" it names.
    RG12: entry('RG12', { variant: 'print', cta: 'landingC9Cta', headline: 'landingRG12Headline', subhead: 'landingRG9Subhead' })
  };
  // Plan 69 T12: the race-course ad (`tf-rc-…`) points at /pages/race-course, so its
  // C12 lands there on New York, unlike the round-1 C12 that points at the product page.
  var raceCourse = {
    C12: race('C12', 'nyc')
  };
  function race(concept, course) {
    return entry(concept, { course: course, headline: 'landing' + concept + 'Headline', disclaimer: 'landingRaceDisclaimer', primary: 'race' });
  }
  var OVERRIDDEN = 'tf_creative_overridden';

  function landingFor(param) {
    var match = typeof param === 'string' && /^tf-(?:r1-(C\d+)|rg-(RG\d+)|rc-(C\d+))(?:-[A-Za-z0-9]+)*$/.exec(param);
    var found = match && (match[3] ? raceCourse[match[3]] : landings[match[1] || match[2]]);
    return Object.assign({}, found || unchanged);
  }

  // Called by preview initialization after its change handlers are installed,
  // before it renders any browser-restored file or asynchronous home handoff.
  function apply(root, copy) {
    var query = new URLSearchParams(window.location.search);
    applyLanding(root, copy, query.get('tf_creative'));
    // Plan 61 T14: the finish-later email links back with the giver's own choices.
    // Applied after the ad's landing, because these are the customer's, not the ad's.
    // Plan 74 T3: `preview` is a customer back for their own run, so it opens as
    // `self`, on the colourway they previewed.
    function applyChoices() {
      var audience = query.get('tf_audience');
      if (audience === 'self' || audience === 'gift') select(root, 'traceform-audience', audience);
      if (audience === 'preview') select(root, 'traceform-audience', 'self');
      var format = query.get('tf_format');
      if (format === 'print' || format === 'framed') select(root, 'traceform-variant', format);
      // Shape-checked because it lands in a selector; an unknown name matches no input.
      var colourway = query.get('tf_colourway');
      if (colourway && /^[a-z]+(?:-[a-z]+)*$/.test(colourway)) select(root, 'traceform-style', colourway);
    }
    applyChoices();
    /* Plan 70 T2. Browsers can restore radios after deferred initialization.
       Reapply only the email's explicit choices after restoration, not the ad. */
    window.addEventListener('pageshow', function () {
      var param = query.get('tf_creative');
      if (param === null) {
        try { param = window.sessionStorage.getItem('tf_creative'); } catch (err) { /* Storage is optional. */ }
      }
      applyLandingCopy(root, copy, landingFor(param));
      applyChoices();
    });
  }

  function select(root, name, value) {
    var input = root.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { traceformLanding: true } }));
  }

  function applyLandingCopy(root, copy, landing) {
    if (!landing.concept || landing.course) return;
    if (landing.cta) root.querySelector('[data-testid="offer-cta"] [data-cta-text]').textContent = copy[landing.cta];
    if (landing.headline) root.querySelector('#traceform-product-title').textContent = copy[landing.headline];
    if (landing.subhead) {
      var subhead = root.querySelector('.pdp-subhead');
      subhead.textContent = copy[landing.subhead];
      subhead.hidden = false;
    }
    var hint = landing.hint && root.querySelector('[data-testid="offer-hint"]');
    if (hint && copy[landing.hint]) {
      hint.textContent = copy[landing.hint];
      hint.hidden = false;
    }
    if (landing.disclaimer) {
      var disclaimer = root.querySelector('[data-testid="landing-disclaimer"]');
      disclaimer.textContent = copy[landing.disclaimer];
      disclaimer.hidden = false;
    }
  }

  function applyLanding(root, copy, param) {
    if (param !== null) {
      try { window.sessionStorage.setItem('tf_creative', param); } catch (err) { /* Storage is optional. */ }
    } else {
      try { param = window.sessionStorage.getItem('tf_creative'); } catch (err) { /* Storage is optional. */ }
    }
    var landing = landingFor(param);
    // A race entry belongs to the race-course page (`traceform-race-course.js`); here
    // its keys are not in the copy, so the product page stays generic.
    if (!landing.concept || landing.course) return;
    applyLandingCopy(root, copy, landing);
    // The ad only picks the starting point: once the customer changes format or
    // audience, its choices stop re-applying; the ad copy still survives reloads.
    try {
      if (window.sessionStorage.getItem(OVERRIDDEN) === param) return;
    } catch (err) { /* Storage is optional. */ }

    if (landing.variant) select(root, 'traceform-variant', landing.variant);
    if (landing.audience === 'gift') {
      select(root, 'traceform-audience', landing.audience);
      var strip = root.querySelector('[data-testid="landing-gift-strip"]');
      strip.hidden = false;
      var ask = strip.querySelector('button');
      var sms = 'sms:?&body=' + encodeURIComponent(copy.landingGiftShare);
      // No share sheet (desktop Firefox): an sms: link does nothing there, so copy the message.
      var fallback = function () {
        if (!navigator.clipboard || !window.isSecureContext) {
          window.location.href = sms;
          return;
        }
        navigator.clipboard.writeText(copy.landingGiftShare).then(function () {
          ask.textContent = copy.landingGiftCopied;
        }, function () {
          window.location.href = sms;
        });
      };
      ask.addEventListener('click', function () {
        if (typeof navigator.share !== 'function') {
          fallback();
          return;
        }
        navigator.share({ text: copy.landingGiftShare }).catch(function (err) {
          if (err.name !== 'AbortError') fallback();
        });
      });
    }

    // Attached after the landing's own selections, so only the customer's changes count.
    root.addEventListener('change', function (event) {
      var name = event.target && event.target.name;
      if (name !== 'traceform-variant' && name !== 'traceform-audience') return;
      if (event.detail && event.detail.traceformLanding) return;
      try { window.sessionStorage.setItem(OVERRIDDEN, param); } catch (err) { /* Storage is optional. */ }
    });
  }

  var api = { landingFor: landingFor, apply: apply };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.TraceformLanding = api;
})();
